<template>
  <div class="explorer-header-bottom">
    <div class="qmkey-chips-header" style="" v-if="title">
      <span class="qmkey-chips-title" style="">{{ title }}</span>
    </div>
    <div class="qmkey-chips-scroll">
      <v-chip-group>
        <component
          class="qmkey-chip"
          v-for="act in whitelist_items"
          :key="act.component+'_'+act.name"
          :is="act.component"
          :item="act"
          :disable="disable"
          @update="update"
        />
      </v-chip-group>
    </div>
  </div>
</template>
  
<style lang="scss">
  @import '@/sass/explorer.scss';
  .explorer-header-bottom {
    display: flex;
    width: 100%;
    align-items: center; 
  }
  .qmkey-chips-header {
    margin-right: 1em;
    margin-left: 1em;
    height: 100%;
  }
  .qmkey-chips-title {
    text-align: center;
    vertical-align: middle;
    font-size: small;
  }
  .qmkey-chip{
    width: fit-content !important;
    align-items: center;
  }
  .v-slide-group__content{
    align-items: center;
  }
  .qmkey-chips-scroll{
    overflow: auto !important;
  }
  </style>
  
<script>
  import ChipList from '@/components/explorer/chips/ChipList';
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
  import ChipUser from '@/components/explorer/chips/ChipUser';
  import ChipDateRange from '@/components/explorer/chips/ChipDateRange';
  import ChipDateField from '@/components/explorer/chips/ChipDateField';
  import ChipProcess from '@/components/explorer/chips/ChipProcess';
  import ChipProcesses from '@/components/explorer/chips/ChipProcesses';
  import ChipAdvancedFilter from '@/components/explorer/chips/ChipAdvancedFilter';
  import ChipDateFilter from '@/components/explorer/chips/ChipDateFilter';
  
  export default {
    name: 'Chips',
  
    props: {
      title: String,
      items: {
        deafult: {},
      },
      disable: {
        type: Boolean,
        default: false,
      },
      whitelist: {
        default: () => {[]}
      }
    },
  
    components: {
      ChipList,
      ChipGeneric,
      ChipUser,
      ChipDateRange,
      ChipDateField,
      ChipProcess,
      ChipProcesses,
      ChipAdvancedFilter,
      ChipDateFilter,
    },

    computed: {
      whitelist_items() {
        if (this.whitelist && this.whitelist.length>1) {
          let items = {}
          for (const [key, value] of Object.entries(this.items)) {
            if (this.whitelist.includes(key) ) {
              items[key] = value;
            }
          }
          return items;
        }else {
          return this.items;
        }
      },
    },
  
    methods: {
      update(something) {
        this.$emit('update',something)
      },
    },
  }  
</script>
  